export const THUMBNAIL_SIZES = {
  CARD_THUMBNAIL_SMALL: {
    width: 90
  },
  CARD_THUMBNAIL_MEDIUM: {
    width: 150
  },
  CARD_THUMBNAIL_LARGE: {
    width: 480
  }
};